import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { prepareQuery } from '@/utils/prepareQuery';

export const settingListRoute: RouteConfig = {
  path: 'settings',
  name: 'settingList',
  component: () => import(/* webpackChunkName: "SettingList" */ '@/views/mainRoute/setting/List.vue'),
  beforeEnter(to, from, next) {
    store
      .dispatch('setting/list', prepareQuery(to))
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.SETTING_CANNOT_LIST }));
  }
};
